import { render, staticRenderFns } from "./MatchSuc.vue?vue&type=template&id=6f68c2a6&"
import script from "./MatchSuc.vue?vue&type=script&lang=js&"
export * from "./MatchSuc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports